import React, { useState } from 'react';
import { Avatar, Button, CssBaseline, TextField } from '@material-ui/core/';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';


const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));


export default function LoginPage(props) {
  const {t, i18n} = props
  const classes = useStyles();

  const [email, setEmail] = useState('Sincere@april.biz');
  const [password, setPassword] = useState('Bret');

  const onEmailChange = e => {
    setEmail(e.target.value);
  }

  const onPasswordChange = async e => {
    e.preventDefault();
    await setPassword(e.target.value);

  }

  const onSubmit = async event => {
    console.log("in on submit");
    event.preventDefault();
    props.doLogin()

  }

  return (<>
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          {t('title')}
        </Typography>

        <form className={classes.form}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label={t('keywords.email')}
            name="email"
            autoComplete="email"
            value={email}
            autoFocus
            onChange={onEmailChange}
          />

          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            value={password}
            label={t('keywords.password')}
            type="password"
            id="password"
            autoComplete="current-password"
            onChange={onPasswordChange}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            onClick={onSubmit}
          >
            {t('btnText.login')}
          </Button>

        </form>
      </div>

    </Container>
  </>

  );
}